export const OPENUI_ASK_POC = 'openui';

export default {
  key: OPENUI_ASK_POC,
  name: 'OpenUI ask panel',
  description:
    "Ask questions about the account or policy you're viewing, or about rejection codes and state rules. Answers come from Claude, so check them before relying on them."
};
